/** Which read endpoint family the classification assistant uses for a line (#13383). */
export enum enumHtsChatScope {
  Importer = 'importer',
  Broker = 'broker',
  /** Support / admin monitoring: entry-level history only (#13385). */
  Admin = 'admin',
}
